import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form"]

  connect() {
    this.submitAfterTyping = this.submitAfterTyping.bind(this)
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  search() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(this.submitAfterTyping, 250)
  }

  submitAfterTyping() {
    this.formTarget.requestSubmit()
  }
}
